import { Link } from "react-router-dom";
import { categories, type Article } from "@/mocks/siteData";

export function ArticleCard({ article, className = "" }: { article: Article; className?: string }) {
  const cat = categories.find((c) => c.slug === article.categorySlug);
  return (
    <article
      className={`group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <Link
        to={`/article/${article.slug}`}
        aria-label={article.title}
        className="block aspect-[3/2] overflow-hidden"
      >
        <img
          src={article.cover}
          alt={`${article.title} · ${cat?.name ?? ""}考古现场图`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-2 flex items-center justify-between gap-2">
          <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-800">
            {cat?.name}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap text-[11px] text-foreground-500">
            <i className="ri-time-line" aria-hidden="true"></i>
            {article.readTime}
          </span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-lg">
          <Link to={`/article/${article.slug}`} className="line-clamp-2">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-auto flex items-center gap-3 border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line" aria-hidden="true"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            {article.date}
          </span>
          <Link
            to={`/article/${article.slug}`}
            className="ml-auto inline-flex items-center gap-1 font-medium text-primary-700 transition-colors hover:text-accent-600"
          >
            阅读
            <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}